export const INVENTORY_META_FIELDS = ['name', 'price', 'updatedAt', 'stockSeedVersion'];

export const extractSizeStock = (data = {}) => {
  const stock = {};
  Object.entries(data).forEach(([key, value]) => {
    if (!INVENTORY_META_FIELDS.includes(key) && Number.isInteger(value)) {
      stock[key] = value;
    }
  });
  return stock;
};

export const buildInitialStock = (sizes, defaultStock = 10) => {
  const stock = {};
  sizes.forEach((size) => {
    stock[size] = defaultStock;
  });
  return stock;
};
